// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"ExternalLink_ProseMirror__1_0uD","externalLink":"ExternalLink_externalLink__WU_YD","externalLink__icon":"ExternalLink_externalLink__icon__1LztW"};